var _path, _path2, _rect, _rect2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAuction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 57,
    viewBox: "0 0 49 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.89 23.082a3 3 0 0 1 3-3h33.078a3 3 0 0 1 3 3v26.063H4.89V23.082zM.738 51.588H48.12a5.373 5.373 0 0 1-5.373 5.373H6.111a5.373 5.373 0 0 1-5.373-5.373z",
    fill: "#00B2CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#00B2CD",
    strokeWidth: 2,
    d: "M15.521 15.923h17.156v12.595H15.521z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.813,
    y: 14.137,
    width: 4.453,
    height: 15.939,
    rx: 2.227,
    fill: "#fff",
    stroke: "#00B2CD",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.992,
    y: 14.137,
    width: 4.453,
    height: 15.939,
    rx: 2.227,
    fill: "#fff",
    stroke: "#00B2CD",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.61 30.82a2.278 2.278 0 0 1 4.55 0l.503 9.27a2.782 2.782 0 1 1-5.556 0l.503-9.27z",
    fill: "#fff",
    stroke: "#00B2CD",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAuction);
export default __webpack_public_path__ + "static/media/ic_auction.3d9d0655a87050dc6c64a59abfe5b8d1.svg";
export { ForwardRef as ReactComponent };